<template>
  <div>
    <br />
    <!-- <vs-button @click="print()" style="margin-left:200px">พิมพ์</vs-button> -->
    <vs-row vs-w="12" style=" margin-bottom: 10px">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="12"></vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="flex-end"
        vs-lg="4"
        vs-sm="4"
        vs-xs="12"
      >
        <vs-button id="selecttime" class="mt-3 w-1/3" @click="print()">Print</vs-button>
        <!-- <v-select
          id="selecttime"
          class="w-full p-1"
          label="name"
          :options="intervel"
          v-model="selectTimeIntervel"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
        />-->
      </vs-col>
    </vs-row>
    <br />
    <center>
      <VuePerfectScrollbar class="scroll-area--customizer-report">
        <table>
          <tbody>
            <tr>
              <td>
                <img
                  src="https://upload.wikimedia.org/wikipedia/th/0/01/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%AA%E0%B8%A3%E0%B8%A3%E0%B8%9E%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B4%E0%B8%95.png"
                  alt
                  width="100px"
                  height="110px"
                />
              </td>
              <td>
                <center>
                  <h2>ระบบตรวจสอบและติดตามเรือขนส่งน้ำมัน</h2>
                  <h2>สำนักตรวจสอบป้องกันและปราบปราม กรมสรรพสามิต</h2>
                </center>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <table style="border: 1px solid; margin-bottom: 10px; width: 900px;">
          <thead>
            <tr style="border-top: 1px solid;">
              <td>
                ชื่อเรือ
                <br />report Name
              </td>
              <td>{{ notification.vessel.name || "-" }}</td>

              <td>
                นามเรียกขาน
                <br />Call Sign
              </td>
              <td>{{ notification.vessel.call_sign || "-" }}</td>

              <td>บริษัท</td>
              <td>{{ notification.vessel.vendor_id || "-" }}</td>
            </tr>
            <tr>
              <td>
                หมายเลขเรือ
                <br />MMSI/IMO
              </td>
              <td>
                {{ notification.vessel.mmsi || "-" }}
                <br />
                {{ notification.vessel.imo_number || "-" }}
              </td>

              <td>
                สถานะเครื่อง AIS
                <br />AIS Status
              </td>
              <td v-if="notification.position_report">Online</td>
              <td v-else>Offline</td>

              <td>
                สัญชาติเรือ
                <br />MID
              </td>
              <td>
                {{ notification.ve || "-" }}
                <br />
                {{ notification.vessel.mid_id || "-" }}
              </td>
            </tr>
            <tr>
              <td>
                ประเภทเรือ
                <br />Ship Type
              </td>
              <td>{{ shipTypeName || "-" }}</td>

              <td>
                ความยาวเรือ
                <br />Length
              </td>
              <td>{{ notification.vessel.length || "-" }}</td>

              <td>
                ความกว้างเรือ
                <br />Breadth
              </td>
              <td>{{ notification.vessel.beam || "-" }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                เหตุการ
                <br />Event
              </td>
              <td>{{ notification.detection_rule.event || "-" }}</td>

              <td>
                พื้นที่
                <br />Zone
              </td>
              <td>{{ notification.detection_rule.zone_id || "-" }}</td>

              <td>
                วันที่
                <br />Date
              </td>
              <td>{{ notification.updated_at|sumtime }} {{ notification.updated_at|sumdate }}</td>
            </tr>
          </tbody>
        </table>

        <div id="map" class="detail-maps"></div>
      </VuePerfectScrollbar>
    </center>
  </div>
</template>
<script>
import axios from "axios";
import gmapsInit from "@/gmap/gmaps";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { API_VESSEL_REPORT } from "@/constants/api";
import { API_BASE_URL } from "@/constants";

export default {
  components: {
    VuePerfectScrollbar
  },
  filters: {
    sumdate: function(string) {
      if (string != null) {
        let year = string.substring(0, 4);
        let sumYear = parseInt(year) + 543;
        let mount = string.substring(5, 7);
        let day = string.substring(8, 10);
        let date = day + "/" + mount + "/" + sumYear;

        return date;
      } else {
        return string;
      }
    },
    sumtime: function(string) {
      if (string != null) {
        return string.substring(11, 19);
      } else {
        return string;
      }
    }
  },
  data() {
    return {
      vessel: {},
      notification: {},
      google: null,
      geocoder: null,
      map: null,
      output: null,
      setMarker: null,
      accessEmail: "",
      accessToken: "",
      notiId: "",
      markers: [],
      all: [],
      shipTypeName: undefined
    };
  },
  created() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    this.notiId = JSON.parse(localStorage.getItem("detailNoti"));
  },
  mounted() {
    this.$vs.loading();
    this.$store.dispatch("updateTitlePage", "DetailNotification");
    console.log("noti id", this.notiId);
    this.getNotification();
    this.all = require("../../milesSea/all.json");
  },
  methods: {
    async initMap() {
      try {
        const google = await gmapsInit();
        this.google = google;
        this.geocoder = new google.maps.Geocoder();
        var latlng = new google.maps.LatLng(
          this.notification.position_report.latitude,
          this.notification.position_report.longitude
        );
        var options = {
          zoom: 11,
          center: latlng,
          streetViewControl: false,
          mapTypeControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          fullscreenControl: true,
          gestureHandling: "greedy"
        };
        this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
        this.infoWindow = new google.maps.InfoWindow();
        this.showMarkers();
        google.maps.event.trigger(this.map, "resize");
        this.map.data.addGeoJson(this.all);
        this.map.data.setStyle(function(feature) {
          var color = feature.getProperty("color");
          if (color == "red") {
            color = "red";
          } else if (color == "green") {
            color = "#10FD1E";
          } else if (color == "blue") {
            color = "#00BDFF";
          }
          return {
            fillColor: color,
            strokeWeight: 0
          };
        });
      } catch (error) {
        console.error(error);
      }
    },
    showMarkers() {
      const google = this.google;
      console.log(
        "show marker",
        this.notification.position_report.latitude,
        this.notification.position_report.longitude
      );

      const latLng = new google.maps.LatLng(
        this.notification.position_report.latitude,
        this.notification.position_report.longitude
      );
      let marker = this.createMarker(this.notification.position_report);
      this.markers.push(marker);
    },
    createMarker(dataVessel) {
      const google = this.google;
      const latLng = new google.maps.LatLng(
        dataVessel.latitude,
        dataVessel.longitude
      );
      var imageUrl = this.getVesselImg(dataVessel);
      var markerImage = this.createMarkerIcon(imageUrl);
      const marker = new google.maps.Marker({
        position: latLng,
        icon: markerImage,
        map: this.map
      });
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    getVesselImg(vessel) {
      const direction = vessel.hdg_cog || vessel.true_heading || 360;
      let iconType = vessel.icon_type;
      const shipType = vessel.navigation_status_id == "1" ? "b" : "";
      let imgShip = "other";
      if (iconType == "tanker") {
        imgShip = "tanker";
      } else if (iconType == "other") {
        imgShip = "other";
      } else if (iconType == "passenger") {
        imgShip = "passenger";
      } else if (iconType == "cargo") {
        imgShip = "cargo";
      } else if (iconType == "fishing") {
        imgShip = "fishing";
      } else if (iconType == "EXCISE") {
        imgShip = "excise";
      }
      const imageUrl = `/vesselIcon/${imgShip}/${shipType}${this.getDirection(
        direction
      )}.png`;
      return imageUrl;
    },
    createMarkerIcon(imageUrl) {
      const google = this.google;
      const markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(50, 50),
        new google.maps.Point(0, 0),
        new google.maps.Point(25, 25),
        new google.maps.Size(50, 50)
      );
      return markerImage;
    },
    getNotification() {
      const url = `${API_BASE_URL}/event_notifications/${this.notiId}.json`;
      axios({
        method: "GET",
        url,
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken
        }
      })
        .then(response => {
          const { data } = response;
          const { vessel } = data;
          this.getShipDetail(vessel.mmsi);
          // this.initMap();
          this.notification = response.data;
        })
        .catch(error => console.log("Error call api:", error))
        .finally(() => this.$vs.loading.close());
    },
    getShipDetail(mmsi) {
      const url = API_VESSEL_REPORT();
      axios
        .get(url, {
          params: {
            utf8: "✓",
            "q[mmsi_cont]": mmsi,
            limit: 1
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(res => {
          console.log(res);
          this.getShipIcon(res.data[0].url);
          const ship_type = res.data[0].ship_type;
          this.notification.position_report.ship_type = {
            ...ship_type
          };
          this.shipTypeName = `${ship_type.id}, ${ship_type.name}`;
        })
        .catch(err => console.log(err));
    },
    getShipIcon(url) {
      const _url = `${API_BASE_URL}${url}`;
      this.$vs.loading();
      axios
        .get(_url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken
          }
        })
        .then(response => {
          const { data } = response;
          console.log(data.icon_type);
          console.log(this.notification);
          this.notification.position_report.icon_type = data.icon_type;
          this.initMap();
        })
        .catch(error => {
          console.log("Error call apis :", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    showMarkersBaseStation() {
      axios
        .get(
          `${API_BASE_URL}/api/base_stations.json?q[longitude_not_null]=1&q[latitude_not_null]=1&_=1578387598505`,
          {
            headers: {
              "X-Usexr-Email": this.accessEmail,
              "X-User-Token": this.accessToken
            }
          }
        )
        .then(response => {
          var markerImage = this.createMarkerIconBase(
            "/vesselIcon/base_stations/online.png"
          );
          for (var i = 0; i < response.data.length; i++) {
            var latLng = new google.maps.LatLng(
              response.data[i].latitude,
              response.data[i].longitude
            );
            this.setMarker = new google.maps.Marker({
              position: latLng,
              icon: markerImage,
              map: this.map
            });
          }
        })
        .catch(error => {
          console.log("Base station Error :", error);
        });
    },

    createMarkerIconBase(imageUrl) {
      var markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(30, 30),
        new google.maps.Point(0, 0),
        new google.maps.Point(15, 15),
        new google.maps.Size(30, 30)
      );
      return markerImage;
    },
    print() {
      window.print();
      //   this.$htmlToPaper("printMe");
    }
  }
};
</script>
<style>
.scroll-area--customizer-report {
  height: calc(100% - 6rem);
  width: 950px;
}
.detail-maps {
  border: 0;
  height: 400px;
  width: 900px;
  padding: 0px;
}
@media print {
  #selecttime {
    display: none;
  }
}
</style>